import React from 'react'
import PayoutProcessor from './PayoutProcessor'
import useNetSuiteImports from './useNetSuiteImports'

const ShopifyPayouts = () => <PayoutProcessor {...useNetSuiteImports({ importType: 1 })} />

export default ShopifyPayouts
